import React, {useState} from 'react'
import { portfolio } from "./Portfolio"
import workimg from "../PortfolioPics/Group 48095388.png"
import NavBar from './NavBar'
import Footer from './Footer'
import Fade from 'react-reveal/Fade';


function PortfolioPage() {

    const [data, setdata] = useState(portfolio)

    console.log(data)

  return (
    <div>

          <div className='container-fluid portfoliopage-div1 ' >
              <div className='container' id='figmafolio'>
                  <Fade top distance="6%" duration={1200}>

                  <h1 className='portfolio-text1' >Creative Work</h1>
                  </Fade>

                  {/* <h1 className='scroll-text1' data-aos="fade-left">Scroll Down For More</h1> */}
                  <Fade top distance="6%" duration={1200}>

                  <h1 className='explore-text1 d-sm-block d-none' >Explore All <svg className='ml-4' width="37" height="14" viewBox="0 0 37 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M37 -2.571e-06L37 14L35 14L35 -2.48357e-06L37 -2.571e-06ZM33 7L27 13L25.59 11.59L29.17 8L-2.62268e-07 8L-3.49691e-07 6L29.17 6L25.59 2.41L27 0.999999L33 7Z" fill="#2F2F2F" />
                  </svg>
                  </h1>
                  </Fade>

                  <div className='row'>
                      {
                          data.map((port) => {
                              return (
                                  <div className='col-lg-6 col-12 d-flex justify-content-center' >
                                      <Fade top distance="3%" duration={1200}>

                                          <div>
                                              <div className="d-flex justify-content-center portfolio-img-div" >
                                                  {port.link && <a href={port.link} target="_blank">
                                                      <img src={port.img} className="portfolio-img img-fluid mx-auto" alt=""  />
                                                  </a>}
                                              </div>
                                              <div className='d-flex align-items-center'>
                                                  <div>
                                                      {port.link && <a href={port.link} target="_blank">
                                                          <h1 className='portfolio-title'>{port.title}</h1>
                                                      </a>}
                                                  </div>
                                                  <div className='ml-auto'>
                                                      {port.link && <a href={port.link} target="_blank">
                                                          <svg width="34" height="34" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                              <rect width="37" height="37" fill="black" />
                                                              <path d="M23.75 14C23.75 13.5858 23.4142 13.25 23 13.25H16.25C15.8358 13.25 15.5 13.5858 15.5 14C15.5 14.4142 15.8358 14.75 16.25 14.75H22.25V20.75C22.25 21.1642 22.5858 21.5 23 21.5C23.4142 21.5 23.75 21.1642 23.75 20.75V14ZM14.5303 23.5303L23.5303 14.5303L22.4697 13.4697L13.4697 22.4697L14.5303 23.5303Z" fill="white" />
                                                          </svg>
                                                      </a>}
                                                  </div>
                                              </div>
                                          </div>
                                      </Fade>
                                  </div>
                              )
                          })
                      }
                  </div>
                  {/* <h1 className='explore-text1 d-sm-none d-block mx-auto' >Explore All <svg className='ml-3' width="37" height="14" viewBox="0 0 37 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M37 -2.571e-06L37 14L35 14L35 -2.48357e-06L37 -2.571e-06ZM33 7L27 13L25.59 11.59L29.17 8L-2.62268e-07 8L-3.49691e-07 6L29.17 6L25.59 2.41L27 0.999999L33 7Z" fill="#2F2F2F" />
                  </svg>
                  </h1> */}
              </div>
          </div>


    </div>
  )
}

export default PortfolioPage